import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _loadingMessage$ :BehaviorSubject<string> = new BehaviorSubject<string>('');

  get isLoading$(): Observable<boolean> {

    return this._isLoading$.asObservable();
  }
  
  get loadingMessage$(): Observable<string> {
    return this._loadingMessage$.asObservable();  }


  public startLoading(message: string = ''): void {
    this._loadingMessage$.next(message);
    this._isLoading$.next(true);
    document.body.style.overflow = 'hidden';
   /// document.querySelectorAll<HTMLElement>('.loader-full')[0].style.height =   window.innerHeight+'px'
  
  }

  public stopLoading(): void {

    this._isLoading$.next(false);
    document.body.style.overflow = 'visible';

  }

  public toggleLoading(): void {
    // eslint-disable-next-line prefer-const
    let toggle = !this._isLoading$.getValue();
    this._isLoading$.next(toggle);
  }
}
